import { CSSProperties } from 'react';
import { ISelector } from '@types';
import {
    EClientsAction,
    ENotifyAction,
    ECardAction,
    ERegFormAction,
} from '@/utils';
import { getRandomNumber } from '../functions';

export const limitNotify = 25;
export const limitClients = 50;
export const limitCardTrans = 6;
export const limitCardChanges = 2;
export const limitBooking = 15;

export const selectStatusBookingOptions = [
    { key: 'request', value: 'request', label: 'Новая заявка' },
    { key: 'ok', value: 'ok', label: 'Отклонить' },
    { key: 'approve', value: 'approve', label: 'Подтвердить' },
];

export const optionsSelect: { value: number; label: EClientsAction }[] = [
    { value: 1, label: EClientsAction.BLOCK },
    { value: 2, label: EClientsAction.ACTIVE },
    { value: 3, label: EClientsAction.SEND_NOTIFICATION },
    { value: 4, label: EClientsAction.ADD_BONUSES },
    { value: 5, label: EClientsAction.DEDUCT_BONUSES },
    { value: 6, label: EClientsAction.DELETE },
];

export const optionsRegFormSelect: { value: number; label: ERegFormAction }[] =
    [
        { value: 1, label: ERegFormAction.BLOCK },
        { value: 2, label: ERegFormAction.ACTIVE },
        { value: 3, label: ERegFormAction.UPDATE_REG_FORM },
        { value: 4, label: ERegFormAction.DELETE_REG_FORM },
    ];

export const optionsCardSelect: { value: number; label: ECardAction }[] = [
    { value: 0, label: ECardAction.BLOCK },
    { value: 1, label: ECardAction.ACTIVE },
    { value: 2, label: ECardAction.CHANGE_TEMPLATE },
];

export const optionsNotifySelect: { value: number; label: ENotifyAction }[] = [
    { value: 1, label: ENotifyAction.CANCEL },
    { value: 2, label: ENotifyAction.DELETE },
    { value: 3, label: ENotifyAction.DUBBLE },
    { value: 4, label: ENotifyAction.EDIT },
];

export const selectOptions: ISelector[] = [
    { key: 'day', value: 'day', label: 'За сегодня' },
    { key: 'week', value: 'week', label: 'За неделю' },
    { key: 'month', value: 'month', label: 'За месяц' },
    { key: 'year', value: 'year', label: 'За год' },
];

export const selectReportsOptions: Array<{
    value: number | string;
    label: string;
}> = [
    { value: 0, label: 'Отчет по выручке' },
    { value: 1, label: 'Отчет по кол-ву чеков' },
    { value: 2, label: 'Отчет по среднему чеку' },
];

export const cssOverride: CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
};
export const customTheme = {
    token: {
        colorPrimary: '#A7388E',
        controlOutline: 'rgba(167, 56, 142, 0.2)',
        boxShadow: '0 1px 1px rgba(167, 56, 142, 0.15)',
        boxShadowSecondary: '0 1px 2px rgba(167, 56, 142, 0.25)',
    },
    components: {
        Select: {
            optionSelectedBg: 'rgba(167, 56, 142, 0.1)',
            optionActiveBg: 'rgba(167, 56, 142, 0.1)',
            optionSelectedIconColor: '#A7388E',
            colorPrimary: 'rgba(167, 56, 142, 1)',
            colorPrimaryHover: 'rgba(167, 56, 142, 0.8)',
        },
    },
};
export const DISPLAY_DATE_FORMAT = 'DD-MM-YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const defaultInventCategory = (shop_id: number) => {
    return {
        id: getRandomNumber(30000, new Set([0])),
        parent_id: 0,
        shop_id: shop_id,
        color: '#000000',
        borderColor: '#000000',
        name_invented: 'Прочее',
    };
};

export const optionsBookingActionsSelect = [
    { value: 'delete', label: 'Удалить' },
];

export const tagColors = [
    'gold',
    'lime',
    'green',
    'cyan',
    'blue',
    'geekblue',
    'purple',
    'magenta',
    'red',
    'volcano',
    'orange',
    'gold',
    'lime',
    'green',
    'cyan',
    'blue',
    'geekblue',
    'purple',
    'magenta',
    'red',
    'volcano',
    'orange',
    'gold',
    'lime',
    'green',
    'cyan',
    'blue',
    'geekblue',
    'purple',
    'magenta',
    'red',
    'volcano',
    'orange',
    '#FBB500',
    '#F56700',
    '#FB0069',
    '#2B1ECA',
    '#6B00F3',
    '#BF6DFF',
    '#0070F3',
    '#14D6BF',
    '#3BCA1E',
    '#A1F01F',
    '#CA281E',
    '#DD1A6A',
    '#FBB500',
    '#F56700',
    '#FB0069',
    '#2B1ECA',
    '#6B00F3',
    '#BF6DFF',
    '#0070F3',
    '#14D6BF',
    '#3BCA1E',
    '#A1F01F',
    '#CA281E',
    '#DD1A6A',
];
export const dataForSwitch = [{ text: 'Рестораны' }, { text: 'Официанты' }];
export const columnsCSV = [
    { title: 'Локальные категории', dataIndex: 'name_invented' },
    { title: 'Категория', dataIndex: 'CATEGORY' },
    { title: 'Наименование', dataIndex: 'NAME' },
    { title: 'Количество', dataIndex: 'QUANTITY' },
];
